export default function({ error }: any) {
  if (process.client && !navigator.cookieEnabled) {
    error({
      message: "Slå på cookies!",
      statusCode: 667,
    });
  }
}
